import Axios from '../config/axios';

// Show Sales Manager approval queue for free-add-on sales closes, plus the
// manager's out-of-office settings (which redirect the approval alert email).

export function getPendingSalesApprovals() {
    return Axios.get('/api/GetPendingSalesApprovals').then(r => r.data);
}

export function reviewSalesApproval(approvalId, action, notes) {
    return Axios.post('/api/ReviewSalesApproval', { approvalId, action, notes }).then(r => r.data);
}

export function getMyOooSettings() {
    return Axios.get('/api/GetMyOooSettings').then(r => r.data);
}

export function updateMyOooSettings(isOutOfOffice, altEmail) {
    return Axios.post('/api/UpdateMyOooSettings', { isOutOfOffice, altEmail }).then(r => r.data);
}
